import module from 'viaticos/module.js'

export const schema = {
  responsable: 'boolean',
  vinculado: 'boolean',
}

export class ViaticosUsuarioColaboradorService {
  constructor ($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get('api/viaticos/usuario/colaborador', {
      schema,
    })
  }
}

module.service('ViaticosUsuarioColaboradorService', ViaticosUsuarioColaboradorService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Usuario/Colaborador.js